import { render, staticRenderFns } from "./alert-error-triangle.vue?vue&type=template&id=4bbedf2e&"
import script from "./alert-error-triangle.vue?vue&type=script&lang=js&"
export * from "./alert-error-triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bbedf2e')) {
      api.createRecord('4bbedf2e', component.options)
    } else {
      api.reload('4bbedf2e', component.options)
    }
    module.hot.accept("./alert-error-triangle.vue?vue&type=template&id=4bbedf2e&", function () {
      api.rerender('4bbedf2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/alert-error-triangle.vue"
export default component.exports